export const CLEAN_FIELDS_BUTTON_TEXT = "Limpiar campos";

export const SPAN_CLASSES = {
  1: "col-span-1",
  2: "col-span-2",
  3: "col-span-3",
  4: "col-span-4",
  5: "col-span-5",
};
